import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import MermaPartForm from "../mermaPartForm";

export const useMermaPart = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const createPart = async () => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <MermaPartForm
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                  // toEdit={stop}
                  // custom
                ></MermaPartForm>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const updatePart = async (mermaPartUuid) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <MermaPartForm
                  uuid={mermaPartUuid}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                  // toEdit={stop}
                  // custom
                ></MermaPartForm>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  return {
    createPart,
    updatePart,
  };
};
